import { emit, events, subscribe } from './eventManager.js';
/**
 * This is a function to close the modal, either by closing it outright, or hitting the "view cart" button
 * which the consumer of the component can intercept, to hook in custom actions.
 *
 * @param successOrData {boolean | ModalCloseData} indicates whether the user closed the cart outright or hit "view cart", or an object with success and cartTotal
 * @param context {string} represents the calling context so that two subscribers can determine if they should handle the event.
 *
 */
function closeModal(successOrData, context) {
    // Handle backwards compatibility - if boolean is passed, convert to object format
    const data = typeof successOrData === 'boolean' ? { success: successOrData } : successOrData;
    // Emit the data object for new subscribers, but also emit boolean for backwards compatibility
    if (data.success) {
        emit(events.DYNAMIC_KIT_ADD_TO_CART, data, context);
        return;
    }
    emit(events.DYNAMIC_KIT_ADD_TO_CART, data, context);
}
/**
 * Subscribe to the modal events (user closed the modal, or user hit view cart)
 *
 * @param callback The callback function to execute when modal events occur
 * @return function used to unsubscribe from the modal events
 *
 * @example
 *     subscribeToModal(callback)
 */
function subscribeToModal(callback) {
    return subscribe(events.DYNAMIC_KIT_ADD_TO_CART, callback);
}
/**
 * Emit a term change event so subscribers (e.g. the ODP hero) can stay in sync
 * when the user changes the subscription term inside the kit-sidebar dropdown.
 *
 * @param term {string} The newly-selected subscription term
 */
function emitTermChange(term) {
    emit(events.DYNAMIC_KIT_TERM_CHANGE, term);
}
/**
 * Subscribe to term-change events emitted by the kit-sidebar dropdown.
 *
 * @param callback {function} Called with the newly-selected term string
 * @return function used to unsubscribe
 */
function subscribeToTermChange(callback) {
    return subscribe(events.DYNAMIC_KIT_TERM_CHANGE, callback);
}
export default {
    closeModal,
    subscribeToModal,
    emitTermChange,
    subscribeToTermChange,
};
